import { render, staticRenderFns } from "./ButtonPopup.vue?vue&type=template&id=080921d7&"
import script from "./ButtonPopup.vue?vue&type=script&lang=js&"
export * from "./ButtonPopup.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports